import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {CryptoService} from 'src/app/services/crypto.service';
import {MemberService} from 'src/app/services/member.service';

@Component({
  selector: 'app-member-data-dialog',
  templateUrl: './member-data-dialog.component.html',
  styleUrls: [ './member-data-dialog.component.scss' ]
})
export class MemberDataDialogComponent implements OnInit {

  public member: any;

  constructor (
    private _memberService: MemberService,
    private _cryptoService: CryptoService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    this.member = this.data

  }

  ngOnInit () {
  }

  updateLink (member) {

    // console.log("member.id: " + JSON.stringify(member.id))
    // console.log("member.letters: " + JSON.stringify(member.letters))

    this._memberService.getById(member.id)
      .subscribe((memberData) => {

        const memberDataCheck: any = {

          "cellPhone": this._cryptoService.set(this._cryptoService.key, memberData.data().cellPhone),
          "changed": false,
          "cpf": this._cryptoService.set(this._cryptoService.key, memberData.data().cpf),
          "email": this._cryptoService.set(this._cryptoService.key, memberData.data().email),
          "image": memberData.data().image,
          "imageChanged": false,
          "moved": false,
          "name": memberData.data().name,
          "text": memberData.data().text,
          "updated": false
        }

        console.log("memberDataCheck: " + JSON.stringify(memberDataCheck))

        member.invites.forEach((invite) => {
          console.log("invite_id: " + invite.invite_id)
          
        })

      })


  }
}
